import IconImage from '@src/assets/images/common/icon/chat-action/icon-image.svg';

type FileUploadDraggingProps = {
  condition: boolean;
  text: string;
  className: string;
  context?: 'main' | 'thread';
};

const FileUploadOverlay = ({
  condition,
  text,
  className,
  context = 'main',
}: FileUploadDraggingProps) => {
  const textStyle =
    context === 'main' ? 'text-sm font-semibold' : 'text-base font-medium text-gray-700';
  return (
    condition && (
      <div className={className}>
        <div
          className={`${
            context === 'main' ? 'rounded-md px-6 py-4' : 'rounded-lg px-3 py-6 text-center'
          } flex items-center gap-2 bg-white shadow-lg`}
        >
          <img
            src={IconImage}
            alt='アップロードする'
            className={context === 'main' ? 'size-5' : 'size-6'}
          />
          <p className={textStyle}>{text}</p>
        </div>
      </div>
    )
  );
};
export default FileUploadOverlay;
